export default {
    props: [ 'info' ]
}



/** WEBPACK FOOTER **
 ** ./src/components/Modal.js
 **/